/*
**************************** 
홈페이지 유저 정보
*****************************
*/

import React, { useEffect, useState } from "react";

import axios from "axios";
import { useParams } from "react-router-dom";
import ConfirmUser from "./ConfirmUser";
import ProfileChange from "./ProfileChange";

export default function Profile(props) {
    const pathData = useParams();
    const [userData, setUserData] = useState({ username: "", name: "", login_id: "", email: "", phone: "", address: "", subAddress: "", password: "", toktokSerial: "" });

    const req = async function (userId) {

        const reqSql = "/api/users/user/" + userId;
        await axios.get(reqSql, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {

            if (res.data.length > 0) {
                const user = res.data[0];
                let copyUserData = {
                    ...userData, username: user.username, name: user.name, login_id: user.login_id, email: user.email, phone: user.phone, address: user.address, subAddress: user.sub_address, password: user.pass, toktokSerial: user.user_key
                };
                setUserData(copyUserData);
            } else {
                if (res.status === 400) {
                    alert("세션 만료 로그인이 필요합니다.");

                } else {
                    alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                }
            }
        }).catch(function (err) {
            console.log(err);
            if (err.code === "ERR_BAD_REQUEST") {
                alert("세션 만료 로그인이 필요합니다.");

            } else {
                alert("데이터 가져오는 도중 오류가 발생하였습니다.");
            }
        });
    }

    useEffect(() => {
        const id = sessionStorage.getItem("userId");
        if (Number(id) !== -1 && id !== null) {
            req(id);
        }
    }, [pathData.state]);

    return (
        <div>
            <div className="modal fade" id="profile" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="profile">회원정보</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => {
                            }}></button>
                        </div>
                        <div className="modal-body">
                            <div className="sign-in">
                                <form action="#">
                                    <div className="form-group text-start">
                                        <label htmlFor="userName" className="form-label mt-4">이름:</label>
                                        <input type="text" className="form-control" name="userName" value={userData.username || ''} disabled></input>
                                    </div>
                                    <div className="form-group text-start">
                                        <label htmlFor="login_id" className="form-label mt-4">아이디:</label>
                                        <input type="text" className="form-control" name="login_id" value={userData.login_id || ''} disabled></input>
                                    </div>
                                    <div className="form-group text-start">
                                        <label htmlFor="email" className="form-label mt-4">이메일:</label>
                                        <input type="email" className="form-control" name="email" value={userData.email || ''} disabled></input>
                                    </div>
                                    <div className="form-group text-start">
                                        <label htmlFor="address" className="form-label mt-4">주소:</label>
                                        <input type="text" className="form-control" name="address" value={userData.address || ''} disabled></input>
                                    </div>
                                    <div className="form-group text-start">
                                        <label htmlFor="subAddress" className="form-label mt-4">상세 주소:</label>
                                        <input type="text" className="form-control" name="subAddress" value={userData.subAddress || ''} disabled></input>
                                    </div>
                                    <div className="form-group text-start">
                                        <label htmlFor="toktokSerial" className="form-label mt-4">톡톡박스 시리얼번호:</label>
                                        <input type="text" className="form-control" name="toktokSerial" placeholder="등록된 톡톡박스가 없습니다." value={userData.toktokSerial || ''} disabled></input>
                                    </div>
                                    <div className="form-group mt-4 row p-2">
                                        <button type="button" className="btn btn-lg btn-primary" data-bs-target="#confirmUser" data-bs-toggle="modal">회원정보 수정하기</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ConfirmUser></ConfirmUser>
            <ProfileChange data={userData}></ProfileChange>
        </div>
    )
}